import { Middleware } from 'redux'
import { isActionOf } from 'typesafe-actions'
import {
    setGlobalEquipmentSearchQuery,
    setGlobalEquipmentSearchQueryState,
    clearGlobalEquipmentSearchQuery,
    clearGlobalEquipmentSearchQueryState,
    setSearchMode,
    setSearchModeState,
    resetSearchMode,
    resetSearchModeState,
} from '../../actions/app/equipmentGlobalSearch.actions'

const globalEquipmentSearchMiddleware: Middleware = (store) => (next) => (action) => {
    next(action)

    if (isActionOf(setGlobalEquipmentSearchQuery, action)) {
        store.dispatch(setGlobalEquipmentSearchQueryState(action.payload))
    }

    if (isActionOf(clearGlobalEquipmentSearchQuery, action)) {
        store.dispatch(clearGlobalEquipmentSearchQueryState())
    }

    if (isActionOf(setSearchMode, action)) {
        store.dispatch(setSearchModeState(action.payload))
    }

    if (isActionOf(resetSearchMode, action)) {
        store.dispatch(resetSearchModeState())
    }
}

export default globalEquipmentSearchMiddleware
